import { ChainedCommands, Editor } from '@tiptap/core';

export interface ActionHandlers {
  action: () => boolean;
  canRunAction: () => boolean;
}

export const createActionHandlers = (
  editor: Editor,
  command: (chain: ChainedCommands) => boolean,
): ActionHandlers => ({
  action: () =>
    editor
      .chain()
      .command(({ chain }) => command(chain()))
      .run(),
  canRunAction: () =>
    editor
      .can()
      .chain()
      .command(({ chain }) => command(chain()))
      .run(),
});
